/**
 * 翻译历史上下文
 * 提供翻译历史管理的上下文和钩子
 */
import { createContext, useContext } from 'react';
/**
 * 创建翻译历史上下文
 */
export const HistoryContext = createContext(null);
/**
 * 使用翻译历史上下文的钩子
 */
export function useHistoryContext() {
    const context = useContext(HistoryContext);
    if (context === null) {
        throw new Error('useHistoryContext must be used within a HistoryProvider');
    }
    return context;
}
//# sourceMappingURL=HistoryContext.js.map